import React, { Fragment, PureComponent } from 'react';
import { VirtualBrand, VirtualPack } from '~/Api/Analytics/VirtualBrand';
import { AnalyticDataSources } from '~/Api/Analytics/VirtualBrand/mapAnalyticVirtualBrand';
import { Country } from '~/Api/Country';
import { Delayed } from '~/Delayed';
import groupArray from '~/libs/groupArray';
import { RegionAvailability } from '~/MedicinalBrandsAnalytics/Region';
import CountryAutocomplete from '~/MedicinalBrandsAnalytics/VirtualBrand/CountryAutocomplete';
import CreateListModal from '~/MedicinalBrandsAnalytics/VirtualBrand/CreateListModal';
import PackPricesTable from '~/MedicinalBrandsAnalytics/VirtualBrand/PackPricesTable';
import RegionSelect from '~/MedicinalBrandsAnalytics/VirtualBrand/RegionSelect';

import styles from './styles.less';

export interface TabState {
	regionAvailability: RegionAvailability | null;
	countryAutocompleteSelectedOptions: { country: Country }[];
}

interface Props {
	virtualBrand: VirtualBrand;
	virtualPack: VirtualPack | null;
	virtualBrandAvailability: { [countryCode: string]: AnalyticDataSources };
	virtualPackAvailability: { [virtualPackId: string]: { [countryCode: string]: AnalyticDataSources } };
	countries: Country[];
	state: TabState | null;
	onStateChange(table: TabState): void;
}

interface State {
	countryAutocompleteValue: string;
	createGroupVirtualPack: VirtualPack | null;
}

export default class PricesTab extends PureComponent<Props, State> {
	state = {
		countryAutocompleteValue: '',
		createGroupVirtualPack: null,
	};

	render() {
		const {
			props: {
				virtualBrand,
				virtualBrandAvailability,
				virtualPackAvailability,
				virtualPack,
				countries,
				state,
				onStateChange,
			},
			state: { countryAutocompleteValue, createGroupVirtualPack },
		} = this;

		const filterCountries =
			(state?.countryAutocompleteSelectedOptions || []).length > 0
				? state?.countryAutocompleteSelectedOptions.map((option) => option.country)
				: state?.regionAvailability?.countries || [];

		return (
			<Fragment>
				<div className={styles.content}>
					<div className={styles.leftColumn}>
						<RegionSelect
							availability={virtualPack ? virtualPackAvailability[virtualPack.id] || {} : virtualBrandAvailability}
							selectedRegionAvailability={state?.regionAvailability || null}
							onSelect={(regionAvailability) =>
								onStateChange({
									...state,
									regionAvailability,
									countryAutocompleteSelectedOptions: [],
								})
							}
						/>
					</div>

					<div className={styles.rightColumn}>
						<div className={styles.select}>
							<CountryAutocomplete
								hideOnSelect
								multiple
								countries={state?.regionAvailability ? state?.regionAvailability.countries : countries}
								// @ts-expect-error this uses completeyl different format for options, beyond comprehension
								selectedOptions={state?.countryAutocompleteSelectedOptions || []}
								value={countryAutocompleteValue}
								onChange={(value) => this.setState({ countryAutocompleteValue: value })}
								onSelect={(options) => {
									this.setState({ countryAutocompleteValue: '' });
									onStateChange({
										...state,
										// @ts-expect-error this uses completeyl different format for options, beyond comprehension
										countryAutocompleteSelectedOptions: options,
									});
								}}
							/>
						</div>

						{virtualPack ? (
							<PackPricesTable
								brandName={virtualBrand.brandName}
								countries={filterCountries || []}
								virtualPack={virtualPack}
								onCreateList={() => this.setState({ createGroupVirtualPack: virtualPack })}
							/>
						) : null}

						{virtualPack ? <hr /> : null}

						{groupArray(virtualBrand.sortedVirtualPacks, 3).map((virtualPacks, i) => {
							const tables = virtualPacks.map((virtualPack) => (
								<PackPricesTable
									brandName={virtualBrand.brandName}
									countries={filterCountries || []}
									key={virtualPack.id}
									virtualPack={virtualPack}
									onCreateList={() => this.setState({ createGroupVirtualPack: virtualPack })}
								/>
							));

							return i > 0 ? (
								<Delayed key={virtualPacks.map((virtualPack) => virtualPack.id).join(',')} milliseconds={i * 5}>
									{tables}
								</Delayed>
							) : (
								tables
							);
						})}
					</div>
				</div>

				{createGroupVirtualPack ? (
					<CreateListModal
						brandName={virtualBrand.brandName}
						virtualPack={createGroupVirtualPack}
						onClose={() => this.setState({ createGroupVirtualPack: null })}
					/>
				) : null}
			</Fragment>
		);
	}
}
